import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { faBell, faCalendarCheck, faClock, faDoorClosed, faSun, faTruck } from '@fortawesome/free-solid-svg-icons';
import LibraryPage, { LibraryCard, LibraryCards } from 'components/layout/LibraryPage';

const SmsTemplateLibraryPage: React.FC = () => {
    const [selected, setSelected] = useState<LibraryCard | null>(null);
    const history = useHistory();

    // Set the sms template options grouped on automatic and manual
    const smsTemplateOptions: LibraryCards[] = [
        {
            groupHeader: 'sms.sms_template.library.automatic_group',
            cards: [
                {
                    type: 'day_before_reminder',
                    icon: faBell,
                    title: 'sms_template.message_type.day_before_reminder',
                    description: 'sms.sms_template.library.day_before_reminder_description'
                },
                {
                    type: 'same_day_morning',
                    icon: faSun,
                    title: 'sms_template.message_type.same_day_morning',
                    description: 'sms.sms_template.library.same_day_morning_description'
                },
            ]
        },
        {
            groupHeader: 'sms.sms_template.library.manual_group',
            cards: [
                {
                    type: 'appointment_booked',
                    icon: faCalendarCheck,
                    title: 'sms_template.message_type.appointment_booked',
                    description: 'sms.sms_template.library.appointment_booked_description'
                },
                {
                    type: 'on_the_way',
                    icon: faTruck,
                    title: 'sms_template.message_type.on_the_way',
                    description: 'sms.sms_template.library.on_the_way_description'
                },
                {
                    type: 'delay',
                    icon: faClock,
                    title: 'sms_template.message_type.delay',
                    description: 'sms.sms_template.library.delay_description'
                },
                {
                    type: 'no_answer',
                    icon: faDoorClosed,
                    title: 'sms_template.message_type.no_answer',
                    description: 'sms.sms_template.library.no_answer_description'
                },
            ]
        },
    ];

    // Open the sms template page for the chosen type
    const openSmsTemplatePage = (card: LibraryCard) => {
        history.push(`/settings/features/sms/template/new/${card.type}`)
    };

    return (
        <LibraryPage
            headerTitle='sms.sms_template.library.header_title'
            backButtonUrl='/settings/features/sms/settings'
            libraryCards={smsTemplateOptions}
            selected={selected}
            setSelected={setSelected}
            onSubmit={openSmsTemplatePage}
        />
    )
};

export default SmsTemplateLibraryPage;
